import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import router from "./router";
import VueCookies from "vue-cookies";
import WordCloud from "vue-wordcloud";

import {
  MdApp,
  MdBottomBar,
  MdButton,
  MdCard,
  MdCheckbox,
  MdContent,
  MdIcon,
  MdList,
  MdMenu,
  MdRipple,
  MdTable,
  MdToolbar
} from "vue-material/dist/components";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import createStore from "./store";

Vue.use(Vuex);
Vue.use(MdApp);
Vue.use(MdBottomBar);
Vue.use(MdIcon);
Vue.use(MdToolbar);
Vue.use(MdButton);
Vue.use(MdRipple);
Vue.use(MdCard);
Vue.use(MdContent);
Vue.use(MdTable);
Vue.use(MdCheckbox);
Vue.use(MdMenu);
Vue.use(MdList);
Vue.use(VueCookies);
Vue.use(WordCloud);
Vue.use(VueGtag, {
  config: {
    bootstrap: false
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store: createStore(),
  render: h => h(App)
}).$mount("#app");
